export default __webpack_public_path__ + "static/media/ldrrmc.e0c069d9.png";